export default [
  {
    path: "/members",
    name: "members",
    component: () => import("../views/members/MembersView.vue"),
  },
  // {
  //   path: "/members/create",
  //   name: "members-create",
  //   component: () =>
  //     import("../views/masterdata/members/form/membersForm.vue"),
  // },
  // {
  //   path: "/members/update/:uuid",
  //   name: "members-update",
  //   component: () =>
  //     import("../views/masterdata/members/form/membersForm.vue"),
  // },
];
